<div class="container-news bg-support-99" *ngIf="block">
    <div class="container">
        <app-header-event [headerData]="headerData">
        </app-header-event>
        <!-- DESKTOP -->
        <div class="d-none d-lg-flex flex-wrap justify-content-between">
            <ng-container *ngFor="let item of blocks; let idx = index;">
                <app-sample-view-card [block]="item" [idx]="idx" class="mb-4" [ngClass]="{
                    'col-12 w-100': idx === 0,
                    'col-12 col-lg-4 h-100 align-items-stretch': idx !== 0,
                    'pe-lg-4': idx === 1 || idx === 2
                }"></app-sample-view-card>
            </ng-container>
        </div>
        <!-- END DESKTOP -->
        <!-- MOBILE -->
        <div class="d-block d-lg-none">
            <ng-container *ngIf="blocks && blocks.length">
                <owl-carousel-o [options]="customOptionsNews" id="carousel-last-news">
                    <ng-container *ngFor="let item of blocks; let idx = index;">
                        <ng-template carouselSlide>
                            <div class="p-2 w-100">
                                <app-sample-view-card [block]="item" [idx]="idx"></app-sample-view-card>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </ng-container>
            <div class="mt-3" *ngIf="headerData.labelLink">
                <a [routerLink]="navigationService.splitUrlRouterLink(headerData.labelLinkUrl).path" [queryParams]="navigationService.splitUrlRouterLink(headerData.labelLinkUrl).queryParams">
                    <button class="btn-header-news-custom w-100 ls-label-small-semibold"
                        [innerHTML]="headerData.labelLink"></button>
                </a>
            </div>
        </div>
        <!-- END MOBILE -->
    </div>
</div>